import type { WeatherLocation } from 'owa-graph-schema';
import WeatherLocationId from 'owa-service/lib/contract/WeatherLocationId';

export default function convertOwsWeatherLocationIdToGqlWeatherLocation(
    owsWeatherLocationId: WeatherLocationId | undefined
): WeatherLocation | undefined {
    if (owsWeatherLocationId == null) {
        return undefined;
    }

    const gqlWeatherLocation: WeatherLocation = {
        Latitude: String(owsWeatherLocationId?.Latitude),
        Longitude: String(owsWeatherLocationId?.Longitude),
        Name: owsWeatherLocationId?.Name,
        LocationId: owsWeatherLocationId?.EntityId,
    };

    return gqlWeatherLocation;
}
